import React from "react";

export const SEVERITY = {
  critical: { color: "#ef4444", text: "#ffffff", label: "Critical" },
  high: { color: "#f97316", text: "#ffffff", label: "High" },
  medium: { color: "#eab308", text: "#000000", label: "Medium" },
  low: { color: "#22c55e", text: "#000000", label: "Low" },
  info: { color: "#3b82f6", text: "#ffffff", label: "Info" },
};

export function SeverityBadge({ severity, cvss, testid }) {
  const s = SEVERITY[severity] || SEVERITY.info;
  return (
    <span
      data-testid={testid}
      className="inline-flex items-center gap-1.5 rounded px-2 py-0.5 text-xs font-semibold font-mono"
      style={{ backgroundColor: s.color, color: s.text }}
    >
      {s.label}
      {cvss !== undefined && <span className="opacity-80">· {cvss}</span>}
    </span>
  );
}

export function SeverityDot({ severity }) {
  const s = SEVERITY[severity] || SEVERITY.info;
  return <span className="inline-block h-2.5 w-2.5 rounded-full" style={{ backgroundColor: s.color }} />;
}
